/**
 * Route Editor Types
 *
 * TypeScript interfaces for the React-first route editing implementation.
 * These types define the shape of route data, duct features, and editor state.
 */
// =============================================================================
// BFT Types and Constants
// =============================================================================
export const BFT_TYPES = [
    { value: '11-way', label: '11-way (24mm)' },
    { value: '12-way', label: '12-way (21.5mm)' },
    { value: '7-way', label: '7-way (16.5mm)' },
    { value: '3-way', label: '3-way (3x12mm)' },
    { value: '16mm-orange', label: '16mm Orange (single)' },
    { value: '16mm-white', label: '16mm White (single)' },
    { value: '7mm-black', label: '7mm Black (single)' },
    { value: '7mm-white', label: '7mm White (single)' },
];
export const STATUS_OPTIONS = ['Planned', 'Roped', 'Installed'];
// =============================================================================
// Utility Types
// =============================================================================
/** Check if a feature is a duct (LineString) */
export function isDuctFeature(feature) {
    return feature.geometry.type === 'LineString';
}
/** Check if a feature is a structure (Point) */
export function isStructureFeature(feature) {
    return feature.geometry.type === 'Point';
}
/** Create default metadata for a new route */
export function createDefaultMetadata() {
    return {
        id: null,
        ourRef: '',
        description: '',
        cableType: '11-way',
        rfs: false,
    };
}
/** Parse NOIs from ORREFERENCEIDS string */
export function parseNois(orreferenceids) {
    if (!orreferenceids)
        return [];
    return orreferenceids.split(',').map(s => s.trim()).filter(Boolean);
}
